// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeHazardous: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#b10631", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="m4.994 8.863 3.87-3.869A.2.2 0 0 1 9 4.938a.2.2 0 0 1 .137.056l3.869 3.87a.2.2 0 0 1 .057.136c0 .05-.02.102-.057.137l-3.87 3.869a.2.2 0 0 1-.136.056.2.2 0 0 1-.137-.056l-3.869-3.87A.2.2 0 0 1 4.938 9a.2.2 0 0 1 .056-.137M8.2 4.332 4.332 8.199a1.13 1.13 0 0 0 0 1.602l3.867 3.867a1.13 1.13 0 0 0 1.602 0l3.867-3.867a1.13 1.13 0 0 0 0-1.602L9.801 4.332a1.13 1.13 0 0 0-1.602 0M9 6.5a.47.47 0 0 0-.469.469v2.187a.468.468 0 1 0 .938 0V6.97A.47.47 0 0 0 9 6.5m.625 4.375a.625.625 0 1 0-1.25 0 .625.625 0 0 0 1.25 0"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeHazardous);
